
// src/helpers/form-validator.js

import each from 'lodash/each'
import at from 'lodash/at'

// rules: {
//   name: {
//     rule: 'isEmail',
//     errorText: '',
//   }
// }

export function linkUI(component, key, onChange = undefined) {
  return (value)=> {
    component.props.updateUI({ [key]: value })
    if (onChange)
      onChange(value)
  }
}

export function resetUI(component, key, onChange = undefined) {
  return (event)=> {
    component.props.updateUI({ [key]: '' })
    if (onChange)
      onChange(undefined)
  }
}

export function linkNativeUI(component, key, onChange = undefined) {
  return (event)=> {
    component.props.updateUI({ [key]: event })
    if (onChange)
      onChange(event)
  }
}

export function validate(ui, rules, callback) {
  var errorState = {}
  var errors = undefined

  each(rules, (rule, key)=> {
    const keys = key.split('.')
    const key0 = keys[0], key1 = keys.slice(1).join('.')
    const value = keys.length == 1 ? ui[key0] : at(ui[key0], key1)[0]
    let error = undefined

    if (rule.rule == 'isEmail') {
      if (!value || !value.toString().trim().match(/^[\d\w+-_.]+@[\d\w+-_.]+$/)) {
        error = true
      }
    } else if (rule.rule == 'isRequired') {
      if (typeof value == 'undefined' || value === null || value.toString().trim().length == 0) {
        error = true
      }
    } else if (rule.rule == 'isNumber') {
      if (typeof value == 'undefined' || value === null || !value.toString().trim().match(/^[-+]?[0-9]+\.?[0-9]*$/)) {
        error = true
      }
    } else if (rule.rule == 'isSame') {
      if (!value || value.toString().trim().length == 0 || value != ui[rule.name]) {
        error = true
      }
    }

    const state = keys.length == 1 ? ui[key0 + 'Error'] : ui[key0][key1 + 'Error']
    if (error) {
      if (keys.length == 1) {
        errorState[key0 + 'Error'] = error
      } else {
        if (errorState[key0])
          errorState[key0][key1 + 'Error'] = error
        else
          errorState[key0] = { [key1 + 'Error']: error }
      }
      errors = true
    }
    else if (state) {
      if (keys.length == 1) {
        errorState[key0 + 'Error'] = error
      } else {
        if (errorState[key0])
          errorState[key0][key1 + 'Error'] = error
        else
          errorState[key0] = { [key1 + 'Error']: error }
      }
    }
  })

  callback(errors, errorState)
}



// WEBPACK FOOTER //
// ./src/helpers/form-validator.js